import { render, staticRenderFns } from "./ParlayInfo.vue?vue&type=template&id=6e48ee2a&scoped=true&"
import script from "./ParlayInfo.vue?vue&type=script&lang=js&"
export * from "./ParlayInfo.vue?vue&type=script&lang=js&"
import style0 from "./ParlayInfo.vue?vue&type=style&index=0&id=6e48ee2a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48ee2a",
  null
  
)

export default component.exports